import React, { CSSProperties } from 'react';
import { BottomOffsetType, Fab, FabActionProps } from '../fab';
import { Icons } from '@unifocus/react-icons';
import classnames from 'classnames';

/**
 * {@docCategory Fabs}
 */
export interface FabsProps {
   /**
    * Called when the Fab is clicked. Do NOT set this if you have actions set.
    */
   onClick?: () => void;

   /**
    * Array of actions.
    */
   actions?: Array<FabActionProps>;

   /**
    * Number from 1 to 8 for setting color.
    * Internally we mod the number by 8 to get an actual color index.
    */
   color?: number;

   /**
    * Sets a className.
    */
   className?: string;

   /**
    * Sets styles.
    */
   style?: CSSProperties;

   /**
    * Extra bottom offset.
    */
   bottomOffset?: BottomOffsetType;
}

const addIcon = <Icons.Add/>;
const approveAllIcon = <Icons.ApproveAll/>;

export class Fabs {
   public static readonly Add = (props: FabsProps) => {
      const className = classnames('uf-fab-add', props.className);

      return (
         <Fab
            icon={addIcon}
            color={props.color || 1}
            className={className}
            style={props.style}
            bottomOffset={props.bottomOffset}
            actions={props.actions}
            onClick={props.onClick}
         />
      );
   };

   public static readonly ApproveAll = (props: FabsProps) => {
      const className = classnames('uf-fab-approve-all', props.className);

      return (
         <Fab
            icon={approveAllIcon}
            color={props.color || 1}
            className={className}
            style={props.style}
            bottomOffset={props.bottomOffset}
            actions={props.actions}
            onClick={props.onClick}
         />
      );
   };
}
